import React, { } from "react";
import { IoEyeSharp } from "react-icons/io5";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function SalesTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Sales Type", field: "salestype" },
    { label: "Sales Category", field: "salescategory" },
    { label: " Sales invoice No.", field: "invoiceno" },
    { label: "Sales Invoice Date", field: "invoicedate" },
    { label: "Customer ", field: "customer" },
    { label: "Warehouse Name", field: "warehousename" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"SALES LIST"}
        apiField={"sales"}
        addButton={"+ ADD"}
        createRoute={"/salesCreate"}
        updateRoute={"/salesView"}
        viewRoute={"/salesView"}
      />
    </div>
  );
}

export default SalesTable;
